import { render, staticRenderFns } from "./VxDatePicker.vue?vue&type=template&id=77dc420c&"
import script from "./VxDatePicker.vue?vue&type=script&lang=js&"
export * from "./VxDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./VxDatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports